// src/modules/goldVault/pages/TransferReceipts.jsx
// HO view: transfers dispatched, in transit, awaiting receipt.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Table, Button, Tag, Typography, Row, Col, Spin,
} from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { getTransfers } from '../api';

const { Title } = Typography;
const STATUS_COLOR = { DISPATCHED: 'orange', IN_TRANSIT: 'gold', RECEIVED: 'lime' };
const fmtW = (v) => `${Number(v || 0).toFixed(3)}g`;

export default function TransferReceipts() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 15, total: 0 });

  useEffect(() => { load(); }, [pagination.current]);

  const load = async () => {
    setLoading(true);
    try {
      // Fetch dispatched + in transit transfers
      const [r1, r2] = await Promise.all([
        getTransfers({ status: 'DISPATCHED', page: pagination.current, limit: 50 }),
        getTransfers({ status: 'IN_TRANSIT', page: 1, limit: 50 }),
      ]);
      const combined = [...(r1.data || []), ...(r2.data || [])];
      setData(combined);
      setPagination((p) => ({ ...p, total: combined.length }));
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const columns = [
    {
      title: 'Transfer No.', dataIndex: 'transferNumber', key: 'tn', width: 140,
      render: (v, r) => <Button type="link" size="small" onClick={() => navigate(`/vault/transfers/${r._id}`)}>{v}</Button>,
    },
    { title: 'Status', dataIndex: 'status', key: 'st', width: 110,
      render: (v) => <Tag color={STATUS_COLOR[v] || 'default'}>{v}</Tag> },
    { title: 'Source Branch', key: 'sb', width: 130,
      render: (_, r) => r.sourceBranch?.name || '—' },
    { title: 'Packages', dataIndex: 'packageCount', key: 'pc', width: 80 },
    { title: 'Gross Wt', dataIndex: 'grossWeight', key: 'gw', width: 100, render: fmtW },
    { title: 'Dispatched At', dataIndex: 'dispatchedAt', key: 'da', width: 130,
      render: (v) => v ? dayjs(v).format('DD MMM YYYY HH:mm') : '—' },
    {
      title: 'Action', key: 'action', fixed: 'right', width: 110,
      render: (_, r) => (
        <Button size="small" type="primary" onClick={() => navigate(`/vault/transfers/${r._id}`)}>
          Receive
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col><Title level={4} style={{ margin: 0 }}>Transfer Receipts</Title></Col>
        <Col><Button icon={<ReloadOutlined />} onClick={load}>Refresh</Button></Col>
      </Row>
      <Spin spinning={loading}>
        <Table
          dataSource={data} rowKey="_id" columns={columns}
          scroll={{ x: 800 }} size="small"
          pagination={{ pageSize: 15, total: data.length }}
        />
      </Spin>
    </div>
  );
}
